module.exports = __webpack_public_path__ + "static/pic03-f9e6217bd9693f2a4fec8b28783d9c57.jpg";